import { Box, Button } from '@mui/material';
import { TestIds } from '../../constants';
import { useFavorites } from '../../contexts/FavoritesContext';
import { getIconComponent } from '../../utils/icons';

const AddIcon = getIconComponent('Add');

interface FavoritesEmptyStateProps {
  /** Disables the CTA once the favorites cap is reached, without hiding it. */
  disabled?: boolean;
}

/**
 * CTA that pins the current page as a favorite. Shown at the bottom of the Favorites section
 * regardless of whether any favorites exist.
 */
export function FavoritesEmptyState({ disabled = false }: FavoritesEmptyStateProps) {
  const { openManagerForCurrentPage } = useFavorites();

  return (
    <Box
      data-testid={TestIds.FAVORITES_EMPTY_STATE}
      role="region"
      aria-label="Add favorites"
      sx={{ px: 2, py: 1 }}
    >
      <Button
        data-testid={TestIds.FAVORITES_EMPTY_ADD_BUTTON}
        onClick={openManagerForCurrentPage}
        variant="outlined"
        color="primary"
        disabled={disabled}
        fullWidth
        startIcon={<AddIcon sx={{ fontSize: 18 }} />}
      >
        Favorite current page
      </Button>
    </Box>
  );
}
